import React, { useEffect } from 'react';
import axios from 'axios';
import {
  List, Box, Typography, Select, MenuItem, BottomNavigation, BottomNavigationAction, TableContainer, Table, TableHead,
  TableBody, TableRow, Paper, Pagination, Snackbar, Alert
} from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import globalStyles from '../../utils/globalStyles';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import legolasApi from '../../api/legolas';
import uilityApi from '../../api/utility';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap',
    borderRadius: '0px !important'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding,
    borderRadius: '0px !important'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export const CustomSelectDate = (props) => {
  const { customDate, setcustomDate, control, selectDate, setSelectDate, retrunDate, dateFilterStatus } = props
  // console.log("props", props)
  const [open, setOpen] = React.useState(false);

  const handleSnackClose = () => {
    setOpen(true);
    setTimeout(() => {
      setOpen(false)
    }, 2000)
  };
  const restructureCustomDate = (date, source) => {
    return source === "from" ? date + " 00:00:00" : date + " 23:59:59";
  }
  const monthDiff = (date1, date2) => {
    var diffMonths =
      (date2.getFullYear() - date1.getFullYear()) * 12 +
      (date2.getMonth() - date1.getMonth());

    console.log("diffmonth", diffMonths)
    return diffMonths + 1 > 6 ? true : false
    // console.log("d1", d1, "d2", d2);
    // let months;
    // months = (d2.getFullYear() - d1.getFullYear()) * 12;

    // console.log("d11", d1, "d2", d2);

    // months -= d1.getMonth();
    // months += d2.getMonth();
    // console.log("minth",months);
    // console.log("dateobj",d1, "last",d2)
    // return months <= 0 ? false : true;
  }

  const handleChangeDate = (event) => {
    let lastMonth, currentMonth;

    if (event.target.name === 'fromDate') {
      const date = new Date(event.target.value)
      currentMonth = date
      const year = currentMonth.getFullYear();
      let month = currentMonth.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let day = currentMonth.getDate();
      day = day < 10 ? "0" + day : day;
      const fromDate = `${year}-${month}-${day}`;
      console.log("fromDate", fromDate)
      let lastMonthFirstDate = restructureCustomDate(fromDate, "from")
      setSelectDate({ ...selectDate, fromDate: lastMonthFirstDate, dateFrom: fromDate })
    }
    if (event.target.name === 'toDate') {
      const date = new Date(event.target.value)
      currentMonth = date
      const years = date.getFullYear();
      let months = date.getMonth() + 1;
      months = months < 10 ? "0" + months : months;
      let days = date.getDate();
      days = days < 10 ? "0" + days : days;
      const toDate = `${years}-${months}-${days}`;
      console.log("toDate", toDate);
      date.setDate(date.getDate() + 1)
      lastMonth = date
      const dateString = selectDate.fromDate
      const dateParts = dateString.split("-");
      const year = parseInt(dateParts[0]);
      const month = parseInt(dateParts[1]) - 1;
      const day = parseInt(dateParts[2]);
      const dateObject = new Date(year, month, day);
      console.log("currentMonth", selectDate.fromDate)
      let lastMonthFirstDate = restructureCustomDate(toDate, "to")
      setSelectDate({ ...selectDate, toDate: lastMonthFirstDate, dateTo: toDate })
      if (monthDiff(dateObject, lastMonth)) {
        setOpen(true);
        return;
      }
    }
  }

  return (
    <>
      {/* {setOpen && <Box>
        <Snackbar open={open} autoHideDuration={3000} onClose={handleSnackClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} >
          <Alert severity="success" sx={{ width: '400px', marginTop: '100px' }}>
            The selected date range should not exceed 6 months
          </Alert>
        </Snackbar>
      </Box>} */}


      {
        dateFilterStatus &&
        <div style={{ "z- index": '100 ', position: 'absolute', backgroundColor: 'white', border: '1px solid #2b3f7a', width: '300px' }}>
          <div style={{ display: 'flex' }}>
            <div style={{ width: '50%' }}>
              <label style={{ marginLeft: "5px" }}>From Date:</label>
              <input type="date" id="date" name='fromDate' style={{ width: '80%', height: '20px', padding: '7px', marginTop: '10px', marginLeft: "5px" }} onChange={handleChangeDate} />
            </div>
            <div style={{ width: '50%' }}>
              <label style={{ marginLeft: "5px" }}>To Date</label>
              <input type="date" id="todate" name='toDate' style={{ width: '80%', height: '20px', padding: '7px', marginTop: '10px', marginBottom: '10px', marginLeft: "5px" }} onChange={handleChangeDate} />
            </div>

          </div>
        </div>
      }
    </>
  )
}

function OrderExports() {
  const { control } = useForm({})

  const [totalCount, setTotalcount] = React.useState(0)
  const [listData, setListData] = React.useState([])
  const [customDate, setcustomDate] = React.useState(false)
  const [showCustomDate, setShowCustomDate] = React.useState({})
  const [currentPage, setCurrentPage] = React.useState(1)
  const [allTableHeaders, setAllTableHeaders] = React.useState([
    { id: 'order_id', label: 'ID', checked: true },
    { id: 'email', label: 'Email', checked: true },
    { id: 'createdAt', label: 'Purchase Date', checked: true },
    { id: 'grandTotal', label: 'Grand Total', checked: true },
    { id: 'order_status', label: 'Shipment Status', checked: true },
    // { id: 'one_day_delivery_charge', label: 'Next Day Delivery',checked: true},
    { id: 'delivery_method', label: 'Delivery Type ', checked: true },
    { id: 'isDiscounted', label: 'addlDisc', checked: true },

    { id: 'payment_registered', label: 'Payment Registered in system', checked: true },
  ])
  const [selected, setSelected] = React.useState([]);
  const [selectDate, setSelectDate] = React.useState({ 'fromDate': null, 'toDate': null, 'dateFrom': null, 'dateTo': null });
  const [exportDisble, setExportDisable] = React.useState(false);
  const [exportError, setExportError] = React.useState(false);
  const [customDateFilterValue, setCustomDateFilterValue] = React.useState(0);
  const [showLoader, setShowLoader] = React.useState(false);
  const [openAlert, setOpenAlert] = React.useState(false);
  const localStorageUser = localStorage.getItem('user');
  const user = JSON.parse(localStorageUser);
  const userid = user.id
  const userChannels = Array.isArray(user?.channel) ? user.channel.map(String).filter(id => id !== "657979c059be05f5f8dd41f7") : [];
  const [channel, setChannel] = React.useState(userChannels);
  const handleErrorMsg = () => {
    setOpenAlert(true)
    setTimeout(() => {
      setOpenAlert(false)
    }, 5000)
  };
  const closeAlert = () => {
    setOpenAlert(false)
  }
  const handleFiltersBtn = () => {
    let filterQuery = {}
    if (selected.length > 0 && selectDate.fromDate && selectDate.toDate) {
      filterQuery = { 'status': selected, 'fromDate': selectDate.fromDate, 'toDate': selectDate.toDate, 'channel': channel }
    }
    else if (selected.length > 0) {
      filterQuery = { 'status': selected, 'channel': channel }
    }
    else if (selectDate.fromDate && selectDate.toDate) {
      filterQuery = { 'fromDate': selectDate.fromDate, 'toDate': selectDate.toDate, 'channel': channel }
    }
    else {
      filterQuery = { 'channel': channel }
    }
    axios.post(`${legolasApi.url}/orders/list`, filterQuery).then((res) => {
      console.log('order res: ', res)
      const data = res.data.data.orders, count = res.data.data.count
      setListData(data)
      setTotalcount(count)
    }).catch((error) => console.log('Error in getting orders: ', error))
  }

  const handleStatusFilter = (event) => {
    const { target: { value }, } = event;
    setSelected(value)
  }
  const handleDateOptionClick = (value) => {
    if (customDateFilterValue === value) {
      setCustomDateFilterValue(0);
      setSelectDate({
        ...selectDate,
        fromDate: "",
        toDate: ""
      });
    }
  }
  const handleDateFilter = (e) => {
    const targetValue = e.target.value;
    console.log("targetValue", targetValue);
    if (customDateFilterValue === targetValue) {
      setCustomDateFilterValue(0);

      setSelectDate({
        ...selectDate,
        fromDate: "",
        toDate: ""
      });

      return;
    }

    let lastMonthEndDate, lastMonthFirstDate;
    setCustomDateFilterValue(targetValue);
    if (targetValue === 1) {
      const currentDate = new Date();
      const prevDate = new Date();
      lastMonthEndDate = retrunDate(prevDate);
      const year = currentDate.getFullYear();
      let month = currentDate.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let day = currentDate.getDate();
      day = day < 10 ? "0" + day : day;
      lastMonthFirstDate = `${year}-${month}-${day} ` + "00:00:00";

    }
    else if (targetValue === 2) {
      const currentDate = new Date();
      const currentFirstDate = new Date();
      currentFirstDate.setDate(1);
      lastMonthFirstDate = retrunDate(currentFirstDate, true);
      lastMonthEndDate = retrunDate(currentDate);
    }
    else if (targetValue === 3) {
      var currentDate = new Date();
      var lastMonthDate = new Date();
      lastMonthDate.setDate(1);
      lastMonthDate.setMonth(currentDate.getMonth() - 1);
      var lastMonthLastDate = new Date(lastMonthDate.getFullYear(), lastMonthDate.getMonth() + 1, 0);
      lastMonthFirstDate = retrunDate(lastMonthDate, true)
      lastMonthEndDate = retrunDate(lastMonthLastDate)
    }

    else if (targetValue === 4) {
      var currentDate = new Date();
      var lastMonthDate = new Date();
      lastMonthDate.setDate(1);
      lastMonthDate.setMonth(currentDate.getMonth() - 3);
      var lastMonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
      lastMonthFirstDate = retrunDate(lastMonthDate, true)
      lastMonthEndDate = retrunDate(lastMonthLastDate)
    }

    else if (targetValue === 5) {
      var currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1
      var lastMonthDate = new Date();
      lastMonthDate.setDate(1);
      lastMonthDate.setMonth(currentDate.getMonth() - 6);
      var lastMonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
      lastMonthFirstDate = retrunDate(lastMonthDate, true)
      lastMonthEndDate = retrunDate(lastMonthLastDate)
    }
    console.log("lastMonthFirstDate", lastMonthFirstDate, "lastMonthEndDate", lastMonthEndDate);
    setSelectDate({ ...selectDate, 'fromDate': lastMonthFirstDate, 'toDate': lastMonthEndDate });
  }


  function retrunDate(dateObj, starttime = false) {
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    if (starttime) {
      const fullDate = `${year}-${month}-${day} 00:00:00`
      return fullDate;
    }
    const fullDate = `${year}-${month}-${day} 23:59:59`
    return fullDate;
  }

  const allChannelOptions = { [process.env.REACT_APP_SHABABUNA_CHANNEL_ID]: 'Shababuna', [process.env.REACT_APP_SENSI_CHANNEL_ID]: 'Sensi'};
  const availableChannelOptions = Object.entries(allChannelOptions) .filter(([id]) => userChannels.includes(id));

  React.useEffect(() => {
    if (channel === '') return;
    const fetchAll = {
      "source": "admin"
    }
    if (channel !== '0') {
      if (channel === '1') {
        fetchAll.channel = process.env.REACT_APP_SHABABUNA_CHANNEL_ID;
      } else if (channel === '2') {
        fetchAll.channel = process.env.REACT_APP_SENSI_CHANNEL_ID;
      }
    }
    axios.post(`${legolasApi.url}/orders/list`, fetchAll).then((res) => {
      const data = res.data.data.orders, count = res.data.data.count
      setListData(data)
      setTotalcount(count)
    }).catch((error) => console.log('Error in getting orders: ', error))
  }, [])


  const formatDateAndTime = (inpDate) => {
    let retDate = ''
    const month = inpDate.toLocaleDateString('default', { month: 'short' })
    const date = inpDate.getDate()
    const year = inpDate.getFullYear()
    const formattedTime = inpDate.getHours() + ':' + inpDate.getMinutes() + ':' + inpDate.getSeconds()
    return retDate + month + '  ' + date + ',  ' + year + '  ' + formattedTime
  }

  const handlePagination = (event, value) => {
    let filterQuery = {}
    if (selected.length > 0 && selectDate.fromDate && selectDate.toDate) {
      filterQuery = { 'status': selected, 'fromDate': selectDate.fromDate, 'toDate': selectDate.toDate }
    }
    else if (selected.length > 0) {
      filterQuery = { 'status': selected }
    }
    else if (selectDate.fromDate && selectDate.toDate) {
      filterQuery = { 'fromDate': selectDate.fromDate, 'toDate': selectDate.toDate }
    }
    else {
      filterQuery = { "source": "admin" }
    }
    console.log("filterqueryPagination", filterQuery)
    axios.post(`${legolasApi.url}/orders/list?offset=${value - 1}`, filterQuery).then((res) => {
      // console.log('re.data', res.data)
      const list = res.data
      setCurrentPage(value)
      setListData(list.data.orders)
      setTotalcount(list.data.count)
    })
  }
  const getDateDiff = (d2, d1) => {
    const dateTimeDiff = Math.abs(new Date(d2) - new Date(d1));
    const diffInDays = Math.ceil(dateTimeDiff / (1000 * 60 * 60 * 24)); // diff in days
    console.log("diffInDays", diffInDays);
    return diffInDays;
  }

  const handleChannelilter = (event) => {
    const { target: { value }, } = event;
    setChannel(value);
    setExportDisable(false);
  }
  const handleExport = () => {
    setExportDisable(true);
    setShowLoader(true);
    setExportError(false);
    setOpenAlert(false);
    let exportPayload;
    exportPayload = { action: "ORDER_EXPORT", filter: {} };
  
    if ((selected.length > 0) || (selectDate.fromDate && selectDate.toDate)) {
      // const exportPayload = { action: "ORDER_EXPORT", filter: { 'orderStatus': selected, 'fromDate': selectDate.fromDate, 'toDate': selectDate.toDate } };
       exportPayload = { action: "ORDER_EXPORT", filter: {} };
      if(selected.length > 0){
        exportPayload.filter["orderStatus"] = selected;
        exportPayload.filter["channel"] = channel.length > 1 ? "0" : channel[0];
      }
      if(selectDate.fromDate && selectDate.toDate){
        exportPayload.filter["fromDate"] = selectDate.fromDate;
        exportPayload.filter["toDate"] = selectDate.toDate;
        exportPayload.filter["channel"] = channel.length > 1 ? "0" : channel[0];
        // if(getDateDiff(selectDate.toDate, selectDate.fromDate) > 180){
        //   alert("The selected date range should not exceed 6 months");
        //   setExportDisable(false);
        //   return;
        // } 
      }
    }
    if (channel.length > 1) {
      exportPayload.filter.channel = "0";
    }
    console.log("exportpayload", exportPayload);
    axios.post(`${uilityApi.url}`, exportPayload)
      .then((res) => {
        const deliveryMethodIndex = res.data[0]?.findIndex(header => header === 'delivery_method');
        const extraDiscountIndex = res.data[0]?.findIndex(header => header === 'isDiscounted');

        const csvContent = res.data.map((row, rowIndex) => {
          return row.map((cell, colIndex) => {
            if (rowIndex > 0 && colIndex === deliveryMethodIndex) {
              if (cell === 'next_day_delivery') {
                cell = 'NDD';
              } else if (cell === 'standard') {
                cell = 'SD';
              } else if (cell === 'store_pickup') {
                cell = 'SP';
              }
            }
            if (typeof cell === 'string' && cell.includes(',')) {
              return `"${cell}"`;
            }
            return cell ? cell.toString().trim() : '';
          }).join(',');
        }).join('\r\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const orderExportFileName = "order_export_" + new Date().getTime() + ".csv";
        link.setAttribute('href', window.URL.createObjectURL(blob));
        link.setAttribute('download', orderExportFileName);

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        setExportDisable(false);
        setShowLoader(false);
      })
      .catch((error) => {
        setShowLoader(false);
        handleErrorMsg();
        setExportDisable(false);
        console.log('Error in getting orders: ', error);
      });

  }

  return (
    <React.Fragment>
      <Snackbar open={openAlert} autoHideDuration={3000} onClose={closeAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={closeAlert} severity="error" sx={{ width: '400px', marginTop: '100px' }}>
          An error occurred while exporting
        </Alert>
      </Snackbar>
      <Box sx={{ margin: '0px', padding: '0px', }}>
        <List actions={null}>
          <Box sx={globalStyles.headerWrapperBox}>
            <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px' }}>
              <Typography variant='h4'>Orders Exports</Typography>
              <Typography variant='subtitle1' sx={globalStyles.headerCountSubtitle}>
                {totalCount} record(s) found
              </Typography>
            </Box>
          </Box>
          {/* <Box sx={globalStyles.headerWrapperBox}>
            <Box sx={{
              width: '100%',
              display: 'flex',
              margin: '0px 30px',
                width: '300px !important',
                padding: '5px 10px !important'
              },
              '& .MuiSvgIcon-root': {
                paddingRight: '10px'
              },
              justifyContent: 'space-between'
            }}>
              <Box sx={{ width: '42%', display: 'flex', justifyContent: 'space-between' }}>
              <Box>
                <Typography>Filter By Status</Typography>
              </Box>
              <Box style={{marginLeft:'50px'}}>
                <Typography>Filter By Date</Typography>
              </Box>
              </Box>

            </Box>
          </Box> */}
          <Box sx={globalStyles.headerWrapperBox}>


            <Box sx={{
              width: '100%',
              display: 'flex',
              margin: '0px 30px',
              '& .MuiInput-input': {
                width: '300px !important',
                padding: '5px 10px !important'
              },
              '& .MuiSvgIcon-root': {
                paddingRight: '10px'
              },
              justifyContent: 'space-between'
            }}>

              <Box sx={{ width: '85%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography>Filter By Status</Typography>
                  <form>
                    <Controller
                      name='status'
                      control={control}
                      //rules={{ required: true}}
                      render={({ field }) =>
                        <Select
                          label="Filter By Status"
                          id="select-order-status"
                          // labelId="demo-simple-select-disabled-label"
                          multiple
                          // defaultValue={'Select Status'}
                          value={selected}
                          onChange={handleStatusFilter}
                          sx={{ border: '1px solid #2b3f7a', width: '200px', marginRight: '10px' }}
                        >
                          <MenuItem value={1}>Pending</MenuItem>
                          <MenuItem value={2}>Processing</MenuItem>
                          <MenuItem value={3}>Order Shipped</MenuItem>
                          <MenuItem value={4}>Closed</MenuItem>
                          <MenuItem value={5}>Cancelled</MenuItem>
                          <MenuItem value={8}>Delivered</MenuItem>
                        </Select>
                      }
                      type='number'
                    />
                  </form>
                </Box>
                <Box>
                  <Typography>Filter By Date</Typography>
                  <form>

                    <Controller
                      name='Date'
                      control={control}
                      //rules={{ required: true}}
                      render={({ field }) =>


                        <Select
                          label="Filter By Status"
                          id="select-date-filter"
                          labelId="select-date-filter-label"
                          // defaultValue={'Select Status'}
                          value={customDateFilterValue || ""}

                          onChange={handleDateFilter}
                          sx={{ border: '1px solid #2b3f7a', width: '400px' }}
                        >
                          <MenuItem value={1} onClick={() => handleDateOptionClick(1)}>Today</MenuItem>
                          <MenuItem value={2} onClick={() => handleDateOptionClick(2)}>Current Month</MenuItem>
                          <MenuItem value={3} onClick={() => handleDateOptionClick(3)}>Last Month</MenuItem>
                          {/* <MenuItem value={4}>3 Month</MenuItem>
                      <MenuItem value={5}>6 Month</MenuItem> */}
                          <MenuItem value={6} onClick={() => {
                            setcustomDate(!customDate)
                            handleDateOptionClick(6)
                          }}>Custom</MenuItem>{/* <MenuItem value={6} >{(!selectDate.fromDate && !selectDate.toDate)  <span>{selectDate.dateFrom} {selectDate.dateTo}</span>}</MenuItem> */}
                        </Select>
                      }
                      type='number'
                    />
                    {(customDateFilterValue === 6) && <CustomSelectDate dateFilterStatus={customDateFilterValue === 6 ? true : (customDateFilterValue === 0 ? true : false)} control={control} customDate={customDate} setcustomDate={setcustomDate}
                      selectDate={selectDate} setSelectDate={setSelectDate} retrunDate={retrunDate} />}
                  </form>
                </Box>
                <Box>

                  <Typography>Filter By Channel</Typography>

                  <form>
                    <Controller
                      name='channel'
                      control={control}
                      //rules={{ required: true}}
                      render={({ field }) =>
                        <Select
                          label="Channel"
                          id="demo-simple-select-disabled"
                          // labelId="demo-simple-select-disabled-label"
                          // multiple
                          // defaultValue={'Select Status'}
                          value={channel.length === userChannels.length ? 'all' : channel} // Show 'all' when all channels are selected
                          onChange={(event) => {
                            const { value } = event.target;
                            if (value === 'all') {
                              setChannel(userChannels); // Select all channels
                            } else {
                              setChannel([value]);
                            }
                          }}
                          sx={{ border: '1px solid #2b3f7a', width: '150px' }}
                        >
                          {userChannels.length > 1 && (
                            <MenuItem value="all">All</MenuItem>
                          )}
                          {availableChannelOptions.map(([id, name]) => (
                            <MenuItem key={id} value={id}>{name}</MenuItem>
                          ))}
                          {/* <MenuItem value={0}>All</MenuItem>
                          <MenuItem value={1}>Shababuna</MenuItem>
                          <MenuItem value={2}>Sensi</MenuItem> */}

                        </Select>
                      }
                      type='number'
                    />
                  </form>
                </Box>

                {/* <Typography>Filter By Channel</Typography>
                <form>
                  <Controller
                    name='Date'
                    control={control}
                    //rules={{ required: true}}
                    render={({ field }) =>


                      <Select
                        label="Filter By Status"
                        id="select-date-filter"
                        labelId="select-date-filter-label"
                        // defaultValue={'Select Status'}
                        onChange={handleDateFilter}
                        sx={{ border: '1px solid #2b3f7a', width: '200px' }}
                      >
                        <MenuItem value={1}>All</MenuItem>
                        <MenuItem value={2}>Sensi</MenuItem>
                        <MenuItem value={3}>Shababuna</MenuItem>
                      </Select>
                    }
                    type='number'
                  />
                </form>  */}
                <BottomNavigation
                  showLabels
                  sx={globalStyles.bottomNavigationMenu}>
                  <BottomNavigationAction sx={{
                    width: '10vw',
                    justifyContent: 'center',
                    textAlign: 'end',
                    '& .MuiButton-sizeSmall': {
                      lineHeight: '30px !important'
                    },
                    '& .MuiDivider-root': {
                      borderRightWidth: 'thin !important',
                      borderColor: '#2b3f7a'
                    }
                  }} label="Apply Filter" onClick={handleFiltersBtn} />
                </BottomNavigation>
              </Box>
              <Box sx={{ width: '15%', justifyContent: "end", marginLeft: '10%' }}>
                <Box sx={{
                  // width: '20vw',
                  justifyContent: 'end',
                  textAlign: 'end',
                  '& .MuiButton-sizeSmall': {
                    lineHeight: '30px !important'
                  },
                  '& .MuiDivider-root': {
                    borderRightWidth: 'thin !important',
                    borderColor: '#2b3f7a'
                  }
                }}>
                  <BottomNavigation
                    showLabels
                    sx={globalStyles.bottomNavigationExport}>
                    <BottomNavigationAction
                      label={
                        <>
                          <Box sx={globalStyles.exportLabel}>
                            {showLoader ? (
                              <>
                                Exporting&nbsp;&nbsp;&nbsp;
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                              </>
                            ) : ('Export'
                            )}
                          </Box>
                        </>

                      }
                      disabled={exportDisble}
                      onClick={handleExport}

                    />
                  </BottomNavigation>

                </Box>
              </Box>
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", ml: 36, mt: 1, gap: 6, whiteSpace: "nowrap", }}>
            <Typography variant="body2" sx={{ fontWeight: 500, color: "#2b3f7a" }}>
              <strong>Delivery Type * :</strong> NDD (Next Day Delivery) | SD (Standard Delivery) | *SP (Store Pickup)
            </Typography>

            <Typography variant="body2" sx={{ fontWeight: 500, color: "#2b3f7a" }}>
              <strong>Additional Discount :</strong> *addlDisc
            </Typography>
          </Box>
          <Box>

            <TableContainer component={Paper} sx={{ margin: '20px 30px', width: '94%' }}>
              <Table aria-label="simple table">
                <TableHead sx={{
                  backgroundColor: globalStyles.colors.backgroundPrimary,
                  height: '40px !important',
                  borderRadius: '0 !important',
                  '& .MuiTableCell-root': {
                    color: '#fff !important',
                    padding: '10px !important',
                    borderRight: '2px solid #fff !important',
                    borderRadius: '0 !important'
                  }
                }}>
                  <TableRow>
                    {allTableHeaders.map((header) => {
                      if (header.checked) {
                        return (
                          <StyledTableCell align='center'>{header.label}</StyledTableCell>
                        )
                      }
                    })}

                  </TableRow>
                </TableHead>
                <TableBody>
                  {listData.map((order) => {
                    // console.log("orderData=============", order.payment_response);
                    return (
                      <StyledTableRow id={order.id}>
                        {allTableHeaders.map((header) => {
                          // console.log("header=============", header);
                          if (header.checked) {
                            if (header.id === 'createdAt') {
                              return (
                                <StyledTableCell align='center'>{formatDateAndTime(new Date(order[header.id]))}</StyledTableCell>
                              )
                            } else if (header.id === 'grandTotal') {
                              return (
                                <StyledTableCell align='center'>
                                  {parseFloat(order[header.id]).toFixed(2)}
                                </StyledTableCell>
                              )
                            } else if (header.id === "status" && order[header.id] === "Complete") {
                              return (
                                <StyledTableCell align='center'>
                                  Order Shipped
                                </StyledTableCell>
                              )
                            } else if (header.id === "payment_registered") {
                              return (
                                <StyledTableCell align='center'>
                                  {order.payment_response}
                                </StyledTableCell>
                              )
                            }
                            //    else if (header.id === 'one_day_delivery_charge') {
                            //   return (
                            //     <StyledTableCell align='center'>
                            //      {Number(order[header.id]) > 0 ? "True" : "False"}
                            //     </StyledTableCell>
                            //   )
                            // }
                            else if (header.id === 'delivery_method') {
                              const deliveryMap = { next_day_delivery: 'NDD', standard: 'SD', store_pickup: 'SP' };
                              return (
                                <StyledTableCell align='center'>
                                  {deliveryMap[order?.delivery_method] || '-'}
                                </StyledTableCell>
                              );
                            } else if (header.id === 'isDiscounted') {
                              return (
                                <StyledTableCell align='center'>
                                  {Number(order.extra_discount) === 1 ? "True" : "False"}
                                </StyledTableCell>
                              )
                            }
                            else {
                              return (
                                <StyledTableCell align='center'>
                                  {order[header.id]}

                                </StyledTableCell>
                              )
                            }
                          }
                        })}

                      </StyledTableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box sx={{ justifyContent: 'center' }}>
            <Pagination count={Math.ceil(totalCount / 50)} page={currentPage} onChange={handlePagination} />
          </Box>
        </List>
      </Box>
    </React.Fragment>

  )
}

export default OrderExports;